import React from 'react';
import {
  func,
  shape,
  string,
} from 'prop-types';
import AmexShopSmallEditorialCard from './AmexShopSmallEditorialCard';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexShopSmallEditorial.scss';

const AmexShopSmallEditorial = (
  {
    baseRequestUrl,
    selectedCode,
    editorialConfig: {
      title,
      subtitle,
      contents,
      deep_link_id: hashId,
    },
    handleTagging,
    tagConfig,
    type,
  }
) => {
  const cityContent = contents[selectedCode];
  const requiredKeys = ['image', 'title', 'url'];
  const filteredCards = cityContent
    .filter((item) => requiredKeys.every((i) => Object.prototype.hasOwnProperty.call(item, i)))
    .slice(0, 3)
    .sort((a, b) => a.id - b.id);

  const renderEditorials = () => (
    filteredCards.map((post) => (
      <AmexShopSmallEditorialCard
        baseRequestUrl={baseRequestUrl}
        key={`post_${post.title}`}
        handleTagging={handleTagging}
        post={post}
        tagConfig={tagConfig}
        type={type}
      />
    ))
  );

  const sanitizedTitle = sanitizeString(title);
  const sanitizedSubtitle = sanitizeString(subtitle);

  if (filteredCards.length > 0) {
    return (
      <div className="AmexShopSmallEditorial">
        <div className="AmexShopSmallEditorial__wrapper">
          <h2
            id={hashId}
            className="AmexShopSmallEditorial__title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedTitle,
            }}
          />
          {subtitle && (
            <p
              className="AmexShopSmallEditorial__subtitle"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: sanitizedSubtitle,
              }}
            />
          )}
          <ul className="AmexShopSmallEditorial__list">
            {renderEditorials()}
          </ul>
        </div>
      </div>
    );
  }
  return null;
};

AmexShopSmallEditorial.propTypes = {
  baseRequestUrl: string.isRequired,
  selectedCode: string.isRequired,
  editorialConfig: shape({
    title: string,
    subtitle: string,
    contents: shape({}),
  }).isRequired,
  handleTagging: func.isRequired,
  tagConfig: shape({}).isRequired,
  type: string.isRequired,
};
export default AmexShopSmallEditorial;
